import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';
export const AccordionWrapper = styled(Accordion)`

.accordian{
        min-height:50px !important;
        height:50px;
        
        background-color: rgb(27, 74, 131);
        color: rgb(255, 255, 255);
        border-radius: 3px;
        p{
            font-size: 14px;
            font-weight: 600;
            font-family: 'Noto Sans', sans-serif;
        }
span{
    font-size: 14px;
    padding: 1px 15px;
    font-weight: 300;
    font-family: 'Noto Sans', sans-serif;
}
svg{
    color: #fff;
    font-size: 30px;

}
}


`;